export enum ShiftType {
  WorkingHours = 'Working Hours',
  PermanentNightGuard = 'Permanent Night Guard',
  Morning = 'Morning',
  Evening = 'Evening',
  Night = 'Night',
  Day = 'Day',
}

export const SHIFT_TYPE_I18N = {
  [ShiftType.Day]: 'Tagschicht',
  [ShiftType.Evening]: 'Spätschicht',
  [ShiftType.Morning]: 'Frühschicht',
  [ShiftType.Night]: 'Nachtschicht',
  [ShiftType.PermanentNightGuard]: 'Dauernachtwache',
  [ShiftType.WorkingHours]: 'Arbeitszeiten',
};
